var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "83px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 138.09 133.35",
    style: {
      enableBackground: "new 0 0 138.09 133.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .st0{fill:#FFFFFF;}\r\n        .st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n        .st2{fill:#0D1C3D;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.58,1.56L66.58,1.56C53.64,2.03,33.83,8.11,22.59,18.46C10.74,29.4,3.18,44.96,1.85,61.16    c-1.93,23.63,4.98,42,20.55,54.57c20.77,16.77,51.16,18.31,65.15,14.09c36.71-11.1,45.42-38.27,47.47-49.43    c4.05-22.11-0.01-40.4-12.06-54.33C106.79,7.32,79.81,1.11,66.58,1.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "51.2,49.01 41.82,58.33 69.51,92.79 96.27,48.98 86.36,40.12 67.68,69.73   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.51,94.54c-0.53,0-1.02-0.24-1.36-0.66L40.46,59.43c-0.56-0.7-0.51-1.7,0.13-2.34l9.38-9.31    c0.35-0.35,0.84-0.54,1.33-0.51c0.5,0.03,0.95,0.27,1.26,0.66l14.94,18.79l17.37-27.53c0.28-0.44,0.73-0.73,1.23-0.8    s1.02,0.09,1.4,0.43l9.91,8.86c0.63,0.56,0.77,1.49,0.33,2.21L71,93.71c-0.3,0.49-0.82,0.8-1.38,0.84    C69.59,94.53,69.55,94.54,69.51,94.54z M44.17,58.46l25.15,31.29l24.7-40.45l-7.29-6.52L69.15,70.67    c-0.3,0.48-0.82,0.79-1.38,0.82c-0.57,0.02-1.11-0.22-1.46-0.66l-15.25-19.2L44.17,58.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.58,1.56L66.58,1.56C53.64,2.03,33.83,8.11,22.59,18.46C10.74,29.4,3.18,44.96,1.85,61.16    c-1.93,23.63,4.98,42,20.55,54.57c20.77,16.77,51.16,18.31,65.15,14.09c36.71-11.1,45.42-38.27,47.47-49.43    c4.05-22.11-0.01-40.4-12.06-54.33C106.79,7.32,79.81,1.11,66.58,1.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "51.2,49.01 41.82,58.33 69.51,92.79 96.27,48.98 86.36,40.12 67.68,69.73   "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,94.54c-0.53,0-1.02-0.24-1.36-0.66L40.46,59.43c-0.56-0.7-0.51-1.7,0.13-2.34l9.38-9.31    c0.35-0.35,0.84-0.54,1.33-0.51c0.5,0.03,0.95,0.27,1.26,0.66l14.94,18.79l17.37-27.53c0.28-0.44,0.73-0.73,1.23-0.8    s1.02,0.09,1.4,0.43l9.91,8.86c0.63,0.56,0.77,1.49,0.33,2.21L71,93.71c-0.3,0.49-0.82,0.8-1.38,0.84    C69.59,94.53,69.55,94.54,69.51,94.54z M44.17,58.46l25.15,31.29l24.7-40.45l-7.29-6.52L69.15,70.67    c-0.3,0.48-0.82,0.79-1.38,0.82c-0.57,0.02-1.11-0.22-1.46-0.66l-15.25-19.2L44.17,58.46z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyNetwork);
export default __webpack_public_path__ + "static/media/whyNetwork.2100e3c10b53dcfa6ff10e7c45649ba9.svg";
export { ForwardRef as ReactComponent };